import * as React from 'react';
import { Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import { theme as themes, ThemeName } from '../../../client/theme';

export const ThemeRoute: React.FC<{
  path: string;
  exact: boolean;
  themeName: ThemeName;
  Component: any;
}> = ({ path, exact, themeName, Component }) => {
  const theme = themes[themeName];

  return (
    <ThemeProvider theme={theme}>
      <Route
        exact={exact}
        path={path}
        render={(props) => <Component {...props} themeName={themeName} />}
      />
    </ThemeProvider>
  );
};
